import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()((theme) => ({
    nameCell: {
        display: 'flex',
        alignItems: 'center',
        gap: theme.spacing(0.75),
        minWidth: 0,
    },
    statusDot: {
        width: 8,
        height: 8,
        borderRadius: '50%',
        flexShrink: 0,
    },
    nameText: {
        fontWeight: 500,
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
    },
    showMoreWrapper: {
        borderTop: `1px solid ${theme.palette.divider}`,
        padding: theme.spacing(0.75, 2),
        display: 'flex',
        alignItems: 'center',
        gap: theme.spacing(1),
    },
    showMoreButton: {
        textTransform: 'none' as const,
        fontSize: '0.8125rem',
        fontWeight: 500,
        padding: theme.spacing(0.25, 0.5),
    },
}));
